/**
 * AdminFilterTabs — Uniforme filter-tab-bar voor admin listings.
 *
 * Vervangt de losse filter-implementaties in DebiteurenDashboard,
 * BetalingsregelingenSection, RemindersSection etc.  Elke pagina heeft
 * nu identieke pill-styling, hover, active-state en counter-support.
 *
 * Props:
 *   items    Array<{ key, label, count?: number }>
 *   value    string   (huidige actieve key)
 *   onChange (key) => void
 *   testidPrefix string   (bv. "regelingen-filter" → data-testid="regelingen-filter-active")
 *   size     "sm" | "md"
 */
import React from "react";

export default function AdminFilterTabs({
  items,
  value,
  onChange,
  testidPrefix = "admin-filter",
  size = "md",
}) {
  const pad = size === "sm" ? "px-2.5 py-1 text-[11px]" : "px-3.5 py-1.5 text-xs";
  return (
    <div
      className="flex items-center gap-1 flex-wrap"
      role="tablist"
      data-testid={`${testidPrefix}-container`}
    >
      {items.map((f) => {
        const active = value === f.key;
        return (
          <button
            key={f.key}
            role="tab"
            aria-selected={active}
            type="button"
            onClick={() => onChange(f.key)}
            className={
              `${pad} rounded-full border font-chivo font-bold tracking-wide transition-all ` +
              (active
                ? "bg-brand-900 text-white border-brand-900 shadow-brand-soft"
                : "bg-white text-brand-900 border-slate-200 hover:border-brand-500 hover:text-brand-500")
            }
            data-testid={`${testidPrefix}-${f.key}`}
          >
            {f.label}
            {typeof f.count === "number" ? (
              <span
                className={
                  `ml-1.5 inline-flex items-center justify-center rounded-full px-1.5 min-w-[18px] text-[10px] font-bold ` +
                  (active ? "bg-white/20 text-white" : "bg-brand-50 text-brand-500")
                }
              >
                {f.count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
